import { useValidateListOrder } from '../../filter';
import { useRoutineListOrder } from './useRoutineListOrder';
import { useSetRoutineListOrder } from './useSetRoutineListOrder';

export const useValidateRoutineListOrder = () => {
  return useValidateListOrder(useRoutineListOrder, useSetRoutineListOrder);
};
